import { useContext } from 'react';
import EditSVG from '../../../static/icons/edit.svg'
import SetCustomParameterModal from '../../modals/SetCustomParameterModal/SetCustomParameterModal';
import { ModalContext } from '../../ModalContext';
import { valueTypes } from "utils/builder/ResultClasses";
import { format } from 'date-fns';
import { useSelector } from "react-redux";

export default function CustomParameterSection({ customParameterObject }) {

    const { handleModal } = useContext(ModalContext)
    const { adskViewerSelection } = useSelector((state) => state.viewer);
    const adskSelectionLength = adskViewerSelection?.dbIdArray?.length ?? 0;

    // in order to use the existing editing modal component, I have to make an object that contains relevant values
    const objectForModal = {
        key: customParameterObject.name,
        label: customParameterObject.name,
        value: customParameterObject.name,
        values: customParameterObject.values,
        type: customParameterObject.type,
        selectedValue: customParameterObject.selectedValue,
    }

    const handleCancelModal = () => {
        handleModal(null, true)
    }

    return (
        <section className="custom-parameter-section" onClick={(e) => { e.stopPropagation() }}>
            <div className="custom-parameter-name">
                {customParameterObject.name}
            </div>
            <div className="custom-parameter-value">
                <CustomParameterValueDisplayByType customParameterObject={customParameterObject} />
            </div>
            <button
                type="button"
                className="button-edit-custom-parameter"
                onClick={() => handleModal(<SetCustomParameterModal closeModal={handleCancelModal} optionToEdit={objectForModal} />)}
            >
                <img src={EditSVG} className="edit-svg" alt="edit custom parameter" />
            </button>
        </section>
    );
}

const CustomParameterValueDisplayByType = ({ customParameterObject }) => {
    // return an empty string in case of no value because:
    // 1. We want to show when a parameter has no value
    // 2. If the user does not select an element, the menu will still show a list of all the parameters available in the project.
    if (customParameterObject.selectedValue == null)
        return ''
    else if (customParameterObject.selectedValue === "Varies")
        return "Varies"
    
    switch (customParameterObject.type) {
        case valueTypes.customLink:
        case valueTypes.proLink:
            return <a

                href={customParameterObject.selectedValue}
                target="_blank">
                {customParameterObject.selectedValue}
            </a>

        case valueTypes.customDate:
        case valueTypes.proDate:
            const formattedDate = format(new Date(customParameterObject.selectedValue), 'dd-MM-yyyy');
            return formattedDate

        case valueTypes.customBool:
        case valueTypes.proBool:
            const stringValue = customParameterObject.selectedValue.toString()
            const result = stringValue.charAt(0).toUpperCase() + stringValue.substring(1);
            return (result)

        default:
            return (customParameterObject.selectedValue)
    };
}